export default function CloseModalIcon({
  width = 24,
  height = 25,
}: {
  readonly width?: number
  readonly height?: number
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5303 5.96967C18.8232 6.26256 18.8232 6.73744 18.5303 7.03033L6.53033 19.0303C6.23744 19.3232 5.76256 19.3232 5.46967 19.0303C5.17678 18.7374 5.17678 18.2626 5.46967 17.9697L17.4697 5.96967C17.7626 5.67678 18.2374 5.67678 18.5303 5.96967Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.46967 5.96967C5.76256 5.67678 6.23744 5.67678 6.53033 5.96967L18.5303 17.9697C18.8232 18.2626 18.8232 18.7374 18.5303 19.0303C18.2374 19.3232 17.7626 19.3232 17.4697 19.0303L5.46967 7.03033C5.17678 6.73744 5.17678 6.26256 5.46967 5.96967Z"
        fill="black"
      />
    </svg>
  )
}
